<template>
    <!-- todo: Make this component switch between the question types -->

    <div>
        <strong class="text-lg text-dark">{{ question.title }}</strong>
        <app-label v-if="question.type == 'rating'" class="pb-2">{{ question.question }}</app-label>

        <rating-input v-if="question.type == 'rating'" :modelValue="modelValue"
                      :required="question.required"
                      :placeholder="question.question"
                      @update:modelValue="$emit('update:modelValue', $event)"></rating-input>

        <input-select v-else-if="question.type == 'yesno'"
                      :modelValue="modelValue"
                      :required="question.required"
                      :options="YesNo"
                      :placeholder="question.question"
                      @update:modelValue="$emit('update:modelValue', $event)"></input-select>

        <input-textarea v-else-if="question.type == 'answer'"
                      :modelValue="modelValue"
                      @update:modelValue="$emit('update:modelValue', $event)"
                      :placeholder="question.question"
        ></input-textarea>

        <input-error v-if="error">{{ error }}</input-error>
    </div>
</template>
<script>
import RatingInput from '@/Components/Forms/Inputs/RatingInput.vue';
import InputSelect from '@/Components/Forms/Inputs/InputSelect.vue';
import InputTextarea from '@/Components/Forms/Inputs/InputTextarea.vue';
import AppLabel from "@/Components/Forms/AppLabel.vue";
import InputError from "@/Components/Forms/Inputs/InputError";

export default {
    components: {
        InputError,
        RatingInput,
        InputSelect,
        InputTextarea,
        AppLabel
    },
    props: {
        question: Object,
        modelValue: [String, Number],
        error: String
    },
    computed: {
        YesNo() {
            return ["Yes", "No"];
        }
    }
};
</script>


<style scoped>

</style>
